/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  appTextInput: {
    height: '50px',
    border: '1px solid #848794',
    padding: 12,
    borderRadius: '10px',
    width: '100%',
  },
};

function AppTextInput({
  type,
  name,
  onChange,
  value,
  placeholderText,
  className,
  label,
  errorText,
  ...rest
}) {
  return (
    <div className="position-relative app-text-input">
      <label
        className={`position-absolute text-input-label ${
          rest.required ? 'required' : ''
        }`}
      >
        {label}
      </label>
      <input
        value={value}
        name={name}
        style={styles.appTextInput}
        placeholder={placeholderText}
        className={`${className} ${
          errorText &&
          errorText !== '' &&
          (value === undefined ||
            value === '' ||
            value.toString().trim() === '') &&
          'error-border'
        }`}
        onChange={onChange}
        type={type}
        disabled={rest.disabled}
        {...rest}
      />
      {errorText &&
        errorText !== '' &&
        (value === undefined ||
          value === '' ||
          value.toString().trim() === '') && (
          <small className="app-error-text">{errorText}</small>
        )}
    </div>
  );
}

AppTextInput.defaultProps = {
  type: 'text',
  className: '',
  placeholderText: '',
  label: '',
  name: '',
  errorText: '',
};

AppTextInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  placeholderText: PropTypes.string,
  errorText: PropTypes.any,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AppTextInput;
